// Helper: Reads an array of IDs from a collection concurrently
export default async function readIds(collection, ids) {
  const reads = ids.map(id => collection.doc(id).get())
  const result = await Promise.all(reads)

  return result.map(v => ({ ...v.data(), id: v.id }))
}
